<template>
	<div>
		<h1>Data Collection, Management and Analysis</h1>
		<!--Slpit the first question-->
		<InputSelectMulti
			question="Who will be collecting data?"
			:options="CollectorsOptions"
			v-model="$tera.project.TrialWizard.collectors"
			bookmark="people-collecting"
		/>

		<InputSelectMulti
			question="How will the data be collected?"
			:options="CollectionOptions"
			v-model="$tera.project.TrialWizard.collections"
			bookmark="collection-method"
		/>

		<InputSelectMulti
			question="Where will the data be stored?"
			:options="StorageOptions"
			v-model="$tera.project.TrialWizard.storage"
			bookmark="data-stored"
		/>

		<InputSelectMulti
			question="Processes to ensure data security (please select all that apply)"
			:options="SecurityOptions"
			v-model="$tera.project.TrialWizard.security"
			bookmark="data-security"
		/>

		<!--Old Question
		<InputTextSingleLine
			question="Plans for data entry, coding, security and storage"
			placeholder="e.g. entry of data by Nurses onto iPads"
			v-model="$tera.project.dataManagement"
		/>-->

		<!--New second questions with dropdown list-->
		<InputSelectMulti
			question="Processes to promote data quality"
			:options="DataQualityOptions"
			v-model="$tera.project.TrialWizard.dataQualityProcess"
			bookmark="data-quality"
		/>

		<!--Old Question
		<InputTextSingleLine
			question="Processes to promote data quality"
			placeholder="e.g. double entry by two independent researchers"
			v-model="$tera.project.dataQuality"
		/>-->

		<InputSelectMulti
			question="Further details are provided in the..."
			:options="furtherDetailsOptions"
			v-model="$tera.project.TrialWizard.furtherDetails"
			bookmark="further-details"
		/>

		<InputSelectMulti
			question="What statistical measure and/or test will be used for primary outcome analysis"
			:options="primaryMeasures"
			v-model="$tera.project.TrialWizard.primaryMeasure"
			bookmark="statistical-measure"
		/>

		<InputSelectMulti
			question="What statistical measure and/or test will be used for secondary outcome analysis"
			:options="secondaryMeasures"
			v-model="$tera.project.TrialWizard.secondaryMeasure"
			bookmark="statistical-measure"
		/>

		<!--Old Question
		<InputTextSingleLine
			question="What statistical measure and/or test will be used for primary outcome analysis"
			placeholder="e.g. relative risk using a Chi-squared test"
			v-model="$tera.project.primaryMeasure"
		/>
		<InputTextSingleLine
			question="What statistical measure and/or test will be used for secondary outcome analysis"
			placeholder="e.g. mean difference using a two-sample T-test"
			v-model="$tera.project.secondaryMeasure"
		/>
		<InputTextSingleLine
			question="How were adverse events analysed"
			placeholder="e.g. reporting the frequency and percentage of all common reported adverse events"
			v-model="$tera.project.adverseEventMeasure"
		/>
		<InputTextSingleLine
			question="How were subgroups categorised"
			placeholder="e.g. age groups"
			v-model="$tera.project.subgroupAnalysis"
		/>
		<InputTextSingleLine
			question="How will subgroup analyses be performed"
			placeholder="e.g. interaction terms in regression models"
			v-model="$tera.project.subgroupComparison"
		/>
		<InputTextSingleLine
			question="Adjusted analysis was performed for the primary outcome by..."
			placeholder="e.g. regression analysis"
			v-model="$tera.project.subgroupMethod"
		/>
		<InputTextSingleLine
			question="What population was the efficacy comparisons performed"
			placeholder="e.g. all eligible participants who were randomized to a study group"
			v-model="$tera.project.efficacyPopulation"
		/>
		<InputTextSingleLine
			question="What was the safety population defined as"
			placeholder="e.g. all participants who received at least one dose of the study intervention"
			v-model="$tera.project.safetyPopulation"
		/>
		<InputTextSingleLine
			question="List the type of planned sensitivity analyses"
			placeholder="e.g. analysis population (per-protocol)"
			v-model="$tera.project.sensitivityAnalyses"
		/>
		-->

		<InputSelectMulti
			question="How were adverse events analysed (select all that apply)"
			:options="adverseEventMeasures"
			v-model="$tera.project.TrialWizard.adverseEventMeasure"
			bookmark="events-analysed"
		/>

		<InputSelectMulti
			question="How were subgroups categorised"
			:options="subgroupAnalysis"
			v-model="$tera.project.TrialWizard.subgroupAnalysis"
			bookmark="subgroups"
		/>

		<InputSelectMulti
			question="How will subgroup analyses be performed"
			:options="subgroupComparison"
			v-model="$tera.project.TrialWizard.subgroupComparison"
			bookmark="subgroup-performed"
		/>

		<InputSelectMulti
			question="Adjusted analysis was performed for the primary outcome by..."
			:options="subgroupMethod"
			v-model="$tera.project.TrialWizard.subgroupMethod"
			bookmark="adjusted"
		/>

		<InputSelectMulti
			question="Efficacy comparisons were performed based on the..."
			:options="efficacyComparisonsOptions"
			v-model="$tera.project.TrialWizard.efficacyComparisons"
			bookmark="efficacy-comparisons"
		/>

		<InputSelectMulti
			question="What population was the efficacy comparisons performed"
			:options="efficacyPopulation"
			v-model="$tera.project.TrialWizard.efficacyPopulation"
			bookmark="population-comparisons"
		/>

		<InputSelectMulti
			question="What was the safety population defined as"
			:options="safetyPopulation"
			v-model="$tera.project.TrialWizard.safetyPopulation"
			bookmark="safety-population"
		/>

		<InputSelectMulti
			question="Missing data was ..."
			:options="missingDataOptions"
			v-model="$tera.project.TrialWizard.missingData"
			bookmark="missing-data"
		/>

		<InputTextSingleLine
			question="This approach to missing data was used because..."
			placeholder=""
			v-model="$tera.project.TrialWizard.missingDataWhy"
			bookmark="approach-method"
		/>

		<InputSelectMulti
			question="List the type of planned sensitivity analyses"
			:options="sensitivityAnalyses"
			v-model="$tera.project.TrialWizard.sensitivityAnalyses"
			bookmark="sensitivity-analyses"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputDataCollection from "./OutputDataCollection.vue";

export default {
	data() {
		return {
			outputComponent: OutputDataCollection,
			CollectorsOptions: [
				{ label: "Nurses" },
				{ label: "Research assistants" },
				{ label: "Study personnel" }
			],
			CollectionOptions: [
				{ label: "Directly onto iPads" },
				{ label: "On paper CRFs" },
				{ label: "Directly from Electronic Health Records" },
				{ label: "Directly into an Electronic Data Capture system" },
				{ label: "Remotely using a secure web-based portal" },
				{ label: "Directly using mobile devices and applications" },
				{
					label:
						"Optical Character Recognition used to digitize handwritten or printed forms automatically"
				},
				{ label: "Barcodes on CRFs scanned to enter data automatically" }
			],
			StorageOptions: [
				{
					label: "Secure cloud services that comply with regulatory standards"
				},
				{ label: "Secure physical servers with restricted access" }
			],
			SecurityOptions: [
				{
					label:
						"Data encryption to prevent unauthorised access through servers and databases"
				},
				{
					label:
						"Access to data restricted based on user's role within the organization"
				},
				{
					label:
						"Multi-Factor Authentication to provide multiple forms of verification to access data"
				},
				{
					label:
						"Personal identifiers removed from datasets to protect participant privacy"
				},
				{
					label:
						"Data processed so that it cannot be linked back to the individual participants"
				},
				{
					label:
						"Comprehensive logs of all data access and modifications maintained and regularly reviewed"
				},
				{
					label:
						"Staff to receive ongoing training on data security best practices and regulatory requirements"
				},
				{ label: "Data backed up regularly " }
			],
			DataQualityOptions: [
				{ label: "Double entry by two independent researchers" },
				{
					label:
						"A random subset of data will be re-entered by a second researcher"
				},
				{
					label:
						"Continuous data cleaning processes to identify and correct errors or inconsistencies"
				},
				{
					label:
						"Validation rules to prevent entry of implausible or inconsistent data"
				},
				{
					label:
						"Training programs for data entry personnel to ensure adherence to protocols and data accuracy"
				},
				{
					label:
						"Systems to maintain audit trails implemented to track all data entry and changes "
				}
			],
			primaryMeasures: [
				{ label: "Relative risk using a Chi-squared test" },
				{ label: "Odds ratio using a Wald test" },
				{ label: "Risk difference using a z-test for proportions " },
				{ label: "Mean difference using a two-sample T-test " },
				{
					label:
						"Hazard ratio using a Cox proportional hazards regression model"
				},
				{ label: "Rate ratio using a Poisson regression model" }
			],
			secondaryMeasures: [
				{ label: "Relative risk using a Chi-squared test" },
				{ label: "Odds ratio using a Wald test" },
				{ label: "Risk difference using a z-test for proportions " },
				{ label: "Mean difference using a two-sample T-test " },
				{
					label:
						"Hazard ratio using a Cox proportional hazards regression model"
				},
				{ label: "Rate ratio using a Poisson regression model" }
			],
			adverseEventMeasures: [
				{
					label:
						"Reporting the frequency and percentage of all common reported adverse events"
				},
				{
					label:
						"Descriptively comparing the total numbers of adverse events in each treatment group"
				},
				{ label: "Listing all the serious adverse events by treatment group" },
				{
					label:
						"Reporting the frequency and percentage of all reported adverse events by body system"
				}
			],
			subgroupAnalysis: [
				{
					label:
						"Using prespecified cut-points based on clinically important boundaries"
				},
				{
					label:
						"Using tertiles based on the observed data from the participants"
				},
				{
					label:
						"Based on the median of the observed data from the participants"
				}
			],
			subgroupComparison: [
				{ label: "Interaction terms in regression models" },
				{ label: "The Mantel-Haenszel Test" },
				{ label: "Interaction tests" }
			],
			subgroupMethod: [
				{
					label:
						"Regression analysis with adjustment for pre-specified baseline variables"
				},
				{
					label:
						"Regression analysis with adjustment for baseline variables not balanced by randomisation"
				},
				{
					label:
						"Regression analysis with adjustment for all stratification variables"
				}
			],
			efficacyComparisonsOptions: [
				{ label: "Intention to treat population" },
				{ label: "Modified intention to treat population" },
				{ label: "Per protocol population" }
			],
			efficacyPopulation: [
				{
					label:
						"All eligible participants who were randomised to a study group"
				},
				{ label: "All randomised participants with observed outcomes" },
				{
					label: "All randomised participants that complied with the protocol"
				},
				{ label: "All randomised participants" }
			],
			safetyPopulation: [
				{
					label:
						"All participants who received at lease one dose of the study intervention"
				}
			],
			missingDataOptions: [
				{ label: "Ignored" },
				{ label: "Addressed using multiple imputation" }
			],
			sensitivityAnalyses: [
				{ label: "Analysis population (per-protocol)" },
				{ label: "Analysis population (as-treated)" },
				{ label: "Analysis adjusted for pre-specified baseline variables" }
			],
			furtherDetailsOptions: [{ label: "statistical analysis plan" }]
		};
	}
};
</script>
